import { trackRenterProfileEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';

const EVENT_TEMPLATE_ID = '175';

// https://dataportal.zillowgroup.net/event-registry/7888 renter_profile
export const RACHEL_DOWNLOAD_ATTACHMENTS_EVENT_TYPE_ID = '7888';
export const emitRachelDownloadAttachmentsEvent = () =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: RACHEL_DOWNLOAD_ATTACHMENTS_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'download_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.InteractMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    renter_profile: null,
  });

// https://dataportal.zillowgroup.net/event-registry/7889
export const RACHEL_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID = '7889';
export const emitRachelPreviewAttachmentsEvent = () =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: RACHEL_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'preview_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.InteractMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    renter_profile: null,
  });
